// @ts-check
/**
 * @file SubscriptionBanner.jsx
 * @location src/components/billing/SubscriptionBanner.jsx
 * @role 콕핏 상단 결제 배너 — trial/past_due/cancelled 4분기. active 시 미렌더.
 *
 *  trial daysLeft>1   → 「무료 기간까지 N일」 (정보 배너)
 *  trial daysLeft<=1  → 강조 + 「결제 등록」 CTA
 *  past_due           → 「결제 정보를 갱신해 주세요」 + 「결제 갱신」
 *  cancelled          → 「온점 이용이 정지되었습니다 — 재개」
 */

/**
 * @param {{
 *   status: 'beta'|'free'|'trial'|'active'|'past_due'|'cancelled',
 *   daysLeft: number | null,
 *   onUpgrade: () => void,
 * }} props
 */
export function SubscriptionBanner({ status, daysLeft, onUpgrade }) {
  if (status === 'active') return null;

  if (status === 'beta') {
    return (
      <div className="sub-banner sub-banner-beta" role="status">
        <span>🚀 베타 무료 이용 중 — 모든 기능을 결제 없이 쓸 수 있어요.</span>
      </div>
    );
  }

  if (status === 'free') {
    return (
      <div className="sub-banner sub-banner-free" role="status">
        <span>무료 플랜 · 멤버 3명까지. 더 큰 팀은 업그레이드하세요.</span>
        <button type="button" className="sub-banner-cta" onClick={onUpgrade}>
          업그레이드
        </button>
      </div>
    );
  }

  if (status === 'trial') {
    if (daysLeft == null) return null;
    const urgent = daysLeft <= 1;
    return (
      <div className={`sub-banner sub-banner-trial${urgent ? ' urgent' : ''}`} role="status">
        <span>
          {urgent
            ? '내일 무료 기간이 종료됩니다. 결제 정보를 등록해 주세요.'
            : `무료 기간까지 ${daysLeft}일`}
        </span>
        {urgent && (
          <button type="button" className="sub-banner-cta" onClick={onUpgrade}>
            결제 등록
          </button>
        )}
      </div>
    );
  }

  if (status === 'past_due') {
    return (
      <div className="sub-banner sub-banner-past-due" role="alert">
        <span>결제 정보를 갱신해 주세요.</span>
        <button type="button" className="sub-banner-cta" onClick={onUpgrade}>
          결제 갱신
        </button>
      </div>
    );
  }

  // cancelled
  return (
    <div className="sub-banner sub-banner-cancelled" role="alert">
      <span>온점 이용이 정지되었습니다. 재개하려면 결제를 등록해 주세요.</span>
      <button type="button" className="sub-banner-cta" onClick={onUpgrade}>
        재개
      </button>
    </div>
  );
}
